import React from "react";
import { SecondaryLink } from "./Header.styles";
import { useAuth } from "../../_auth/useAuth";
import { DaMenuItem, MainMenuData } from '../../_appData';
import { useLocation } from 'react-router-dom';

export const NavMenu : React.FC = () => {
    const { isAuthenticated, canNavigateState, userHasPrivilege } = useAuth();
    const location = useLocation();

    /**
     * Check if a menu item should be visible based on user roles
     */
    const isItemVisible = (item: DaMenuItem): boolean => {
        // If no allowedRoles specified, item is visible to all authenticated users
        if (!item.allowedRoles || item.allowedRoles.length === 0) {
            return true;
        }
        // Check if user has at least one of the required roles
        return userHasPrivilege(item.allowedRoles);
    };

    return (
        <>
            {isAuthenticated && canNavigateState &&
                MainMenuData(userHasPrivilege)
                    .filter((item: DaMenuItem) => isItemVisible(item))
                    .map((item: DaMenuItem) => {
                        const selected = location.pathname === item.path;
                        return (
                            <SecondaryLink
                                key={item.label}
                                to={item.path}
                                sx={selected ? {
                                    backgroundColor: '#2e3b4e',
                                    color: '#fff',
                                    fontWeight: 700,
                                    borderRadius: 2,
                                } : {}}
                            >
                                {item.label}
                            </SecondaryLink>
                        );
                    })}
        </>
    );
}